import * as Yup from "yup";

export const FLEET_VEHICLE_INVOICE_EDIT_FORM_SCHEMA = Yup.object().shape({
  invoiceNumber: Yup.string().nullable().required("Broj računa je obavezan"),
  invoiceDate: Yup.date().nullable().required("Datum računa je obavezan"),
  dueDate: Yup.date().nullable().required("Datum dospijeća je obavezan"),
  contactClientId: Yup.string().nullable().required("Kupac je obavezan"),
});
